import React from "react";

const LoadPage = () => {
    return <div style={{ height: '100vh', top: "0", left: "0", width: "100%", zIndex: 1000, backgroundColor: "white" }}></div>
};

export default LoadPage;
